export default {
  "Audio Compressor": "ऑडियो कंप्रेसर",
  "HitPaw Online Audio Compressor": "HitPaw ऑनलाइन ऑडियो कंप्रेसर",
  "Reduce audio file size online without quality loss.": "गुणवत्ता में कमी के बिना ऑनलाइन ऑडियो का फाइल साइज़ कम करें।",
  "Compress": "कंप्रेस करें",
  "Compressing": "कंप्रेस हो रहा है",
  "Compressed Successfully": "सफलतापूर्वक कंप्रेस हुआ",
  "Compress New": "नया कंप्रेस करें",
  "Compression is complete": "कंप्रेशन पूरा हो गया है",
  "Compression failed": "कंप्रेशन विफल",
  "Quality": "गुणवत्ता",
  "Format": "फॉर्मेट",
  "Add file": "फाइल जोड़ें",
  "Output Settings": "आउटपुट सेटिंग",

};
